import BarGraphs from "../../components/UKG/Mathematics/BarGraphs";
import TableGraph from "../../components/UKG/Mathematics/TableGraph";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics - Data Handling";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/data-handling/bar-graph", title: "Bar Graph", component: BarGraphs},
    { url: "/ukg/mathematics/data-handling/tables", title: "Tables", component: TableGraph},
];


export default topics;